<template>
  <v-app login>
    <v-main class="pa-0">
      <v-container class="fill-height pa-0" fluid>
        <v-card class="elevation-0 fill-height" style="width:100%" fluid>
          <v-window v-model="step" class="fill-height" style="width:100%">
            <v-window-item :value="1" class="fill-height">
              <v-row class="fill-height">
                <v-col
                  v-if="this.$vuetify.breakpoint.name != 'xs'"
                  cols="12"
                  md="7"
                  class="bkg"
                >
                </v-col>
                <v-col v-if="this.$vuetify.breakpoint.name == 'xs'" class="bkg">
                </v-col>
                <v-col cols="12" md="5" back align-self="center">
                  <v-card-text justify-center>
                    <v-card max-width="700" align-content-center elevation="0">
                      <v-row
                        justify="center"
                        class="pb-5"
                        align-content="center"
                      >
                        <v-col
                          cols="12"
                          md="5"
                          v-if="this.$vuetify.breakpoint.name != 'xs'"
                        >
                          <v-img
                            lazy-src="../../assets/logo.png"
                            max-height="90%"
                            max-width="90%"
                            src="../../assets/logo.png"
                          ></v-img>
                        </v-col>
                        <v-img
                          align-center
                          v-if="this.$vuetify.breakpoint.name == 'xs'"
                          lazy-src="../../assets/logo.png"
                          max-height="40%"
                          max-width="40%"
                          src="../../assets/logo.png"
                        ></v-img>
                      </v-row>
                      <v-form ref="loginForm" @submit="handleLogin()">
                        <v-row justify="center" align-content="center">
                          <v-col cols="12" md="8">
                            <v-text-field
                              v-model="login.email"
                              label="Email"
                              prepend-icon="mdi-email"
                              type="text"
                              outlined
                              hide-details
                              :rules="emailRules"
                              required
                            />
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-text-field
                              v-model="login.senha"
                              label="Senha"
                              prepend-icon="mdi-lock"
                              type="password"
                              autocomplete="on"
                              outlined
                              hide-details
                              required
                              :rules="passwordRules"
                              @keydown.native.enter="handleLogin()"
                            />
                            <p class="text-end">
                              <a @click="step++">Esqueci minha senha?</a>
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align-content="center">
                          <v-col cols="12" md="8">
                            <v-alert dense text :value="!!message" type="error">
                              <span v-html="message"></span>
                            </v-alert>
                          </v-col>
                        </v-row>
                        <v-row
                          justify="center"
                          class="pb-5"
                          align-content="center"
                        >
                          <v-btn
                            class="px-15"
                            large
                            color="indigo darken-3"
                            rounded
                            dark
                            @click="handleLogin()"
                            >Acessar</v-btn
                          >
                        </v-row>
                      </v-form>
                      <v-row justify="center" align-content="center">
                        <v-col cols="12" md="8">
                          <v-divider />
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="true"
                        justify="center"
                        class="pb-5"
                        align-content="center"
                      >
                        <v-col cols="12" md="8" >
                          <div>
                            <!--p class="text-h8 text-center ">
                              <strong>Ainda não é assinante do MedCof?</strong>
                            </p-->
                            <p class="text-h8 text-center ">
                              Preparamos um projeto para cada área, para que você
                              possa ir mais longe que seus concorrentes nos
                              exames.
                            </p>
                          </div>
                          <div>
                            <p class="text-h8 text-center "><br/>
                            <a
                              large
                              color="indigo darken-3"
                              outlined
                              rounded
                              dark
                              href="https://www.grupomedcof.com.br/linktree-cursos"
                              rel="follow"
                              target="_blank"
                              >Não possui um cadastro? clique aqui</a>
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                      <v-spacer></v-spacer>
                      <v-row
                        v-if="true"
                        justify="center"
                        class="pb-5"
                        align-content="center"
                      >
                        <v-col cols="12" md="8" >
                          <div>
                            <p class="text-h8 text-center "><a @click="showTermos">Termos de uso</a></p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-dialog
                v-model="dialog"
                persistent
                max-width="400"
              >
                <v-card> 
                  <v-card-title>Redirecionamento</v-card-title>
                  <v-card-text>
                  Voçê será redirecionado para o site eduzz.<br/>
                  Após concluir a compra entraremos em contato com você pelo email informado para concluir seu cadastro.
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="termoDialog"
                width="600px"
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">Termo de Uso</span>
                  </v-card-title>
                  <v-card-text>
                    <p v-html="termo"></p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="green darken-1"
                      text
                      @click="termoDialog = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              
            </v-window-item>
            
            <v-window-item :value="2" class="fill-height">
              <v-row class="fill-height">
                <v-col
                  v-if="this.$vuetify.breakpoint.name != 'xs'"
                  cols="12"
                  md="7"
                  class="bkg"
                >
                </v-col>
                <v-col v-if="this.$vuetify.breakpoint.name == 'xs'" class="bkg">
                </v-col>
                <v-col cols="12" md="5" back align-self="center">
                  <v-card-text justify-center>
                    <v-card
                      max-width="700"
                      align-content-center
                      elevation="0"
                      v-if="!this.confirmouEnvio"
                    >
                      <v-row
                        justify="center"
                        class="pb-5"
                        align-content="center"
                      >
                        <v-col
                          cols="12"
                          md="5"
                          v-if="this.$vuetify.breakpoint.name != 'xs'"
                        >
                          <v-img
                            :to="{ name: 'login' }"
                            lazy-src="../../assets/logo.png"
                            max-height="90%"
                            max-width="90%"
                            src="../../assets/logo.png"
                          ></v-img>
                        </v-col>
                        <v-img
                          align-center
                          v-if="this.$vuetify.breakpoint.name == 'xs'"
                          lazy-src="../../assets/logo.png"
                          max-height="40%"
                          max-width="40%"
                          src="../../assets/logo.png"
                        ></v-img>
                      </v-row>
                      <v-row justify="center" align-content="center">
                        <v-col cols="12" md="8">
                          <p class="text-h6 text-center ">Recuperar senha</p>
                          <p class="text-h8 text-center ">
                            Esqueceu sua senha? Digite seu e-mail que enviaremos um link para você prosseguir com o processo de redefinição.
                          </p>
                        </v-col>
                      </v-row>
                      <v-form ref="form" v-model="valido" lazy-validation>
                        <v-row
                          justify="center"
                          align-content="center"
                          class="pb-5"
                        >
                          <v-col cols="12" md="8">
                            <v-text-field
                              label="E-mail"
                              v-model="email"
                              :rules="emailRules"
                              prepend-icon="mdi-email"
                              type="text"
                              outlined
                              required
                            />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align-content="center">
                          <v-btn
                            class="px-15"
                            large
                            color="indigo darken-3"
                            rounded
                            @click="enviar($event)"
                            dark
                            >recuperar</v-btn
                          >
                        </v-row>
                      </v-form>
                    </v-card>
                    <v-card
                      max-width="700"
                      align-content-center
                      elevation="0"
                      v-if="this.confirmouEnvio"
                    >
                      <v-row
                        justify="center"
                        class="pb-5"
                        align-content="center"
                      >
                        <v-col
                          cols="12"
                          md="5"
                          v-if="this.$vuetify.breakpoint.name != 'xs'"
                        >
                          <v-img
                            lazy-src="../../assets/logo.png"
                            max-height="90%"
                            max-width="90%"
                            src="../../assets/logo.png"
                          ></v-img>
                        </v-col>
                        <v-img
                          align-center
                          v-if="this.$vuetify.breakpoint.name == 'xs'"
                          lazy-src="../../assets/logo.png"
                          max-height="40%"
                          max-width="40%"
                          src="../../assets/logo.png"
                        ></v-img>
                      </v-row>
                      <v-row justify="center" align-content="center">
                        <v-col cols="12" md="8">
                          <p class="text-h8 text-center ">
                            Um email com informações de como recuperar sua senha foi enviado.
                          </p>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align-content="center">
                        <v-btn
                          class="px-15"
                          large
                          color="indigo darken-3"
                          rounded
                          @click="voltar"
                          dark
                          >voltar</v-btn
                        >
                      </v-row>
                    </v-card>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import Login from '../../models/login';
  import Termo from '../../components/jsonsHelper/termoUso.json'
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'Login',
    data: () => ({
      dialog: false,
      termoDialog: false,
      termo: Termo.termo,
      login: new Login('', ''),
      message: '',
      step: 1,
      valido: true,
      confirmouEnvio: false,
      nameRules: [(v) => !!v || 'Nome é obrigatório'],
      passwordRules: [(v) => !!v || 'Senha é obrigatório'],
      emailRules: [
        (v) => !!v || 'E-mail é obrigatório',
        (v) => /.+@.+\..+/.test(v) || 'Informe um email válido',
      ],
      email: '',
    }),
    computed: {
      ...mapState('auth', ['isLoggedIn']),
      loggedIn() {
        return this.isLoggedIn;
      },
    },
    props: {
      source: String,
    },
    created() {
      if (this.loggedIn) {
        return this.$router.push('/dashboard');
      }
      if (this.$route.meta.expiredToken)
        this.message = 'Sua sessão expirou, entre novamente.';
    },
    methods: {
      ...mapActions('auth', ['tryToLogin']),
      ...mapActions('user', ['recoverPassword']),
      enviar(event) {
        event.preventDefault();
        this.$refs.form.validate();
        if (this.$refs.form.validate()) {
          this.recoverPassword(this.email)
          this.confirmouEnvio = true;
        }
      },
      voltar() {
        this.step = 1;
        this.email = '';
        this.confirmouEnvio = false;
      },
      async handleLogin() {
        const validate = await this.$refs.loginForm.validate();
        if (!validate) return;
        const resp = await this.tryToLogin(this.login);
        switch (resp.status) {
          case 200:
            this.$router.push({path: '/dashboard'});
            break;
          case 404:
            this.message = 'Usuário ou senha inválida.';
            break;
          case 417:
              this.message = 'Seu usuário não possui uma matrícula ativa, Por favor <a href="https://wa.me/message/DCXGAQZXWSB6L1" target="_blank" rel="nofollow"/>entre em contato com o suporte.</a> ';
              break;
          default:
            this.message = 'Erro interno, Por favor <a href="https://wa.me/message/DCXGAQZXWSB6L1" target="_blank" rel="nofollow"/>entre em contato com o suporte.</a>';
            break;
        }
      },
      cadastrar(){
        this.dialog = true
        setTimeout( () =>  window.location.href = 'https://www.grupomedcof.com.br/', this.dialog = false, 5000);
      }, 
      showTermos(){
        this.termoDialog = true;
      }
    },
  };
</script>

<style scoped> 
  .bkg {
    background-image: url('../../assets/bannerTopo.png');
    background-size: cover;
  }
</style>
